import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AuthInit } from "./modules/Auth";
import { Routes } from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
// import { getToken, onMessage } from "firebase/messaging";
// import { messaging } from "../firebase";

// import { Toast } from "./utility";

export default function App({ store, persistor, basename }) {
  // async function requestPermission() {
  //   const permission = await Notification.requestPermission();

  //   if (permission === "granted") {
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BPu9i6VuihHILkJck-CftBX7Wc_vDxqqS1XqYOeBuGFnzjVB2QvDYCtL38aDAhIeP4ixdxNwwkAXpeooUsFnyr4",
  //     });

  //     console.log("Token generated : ", token);
  //   } else if (permission === "denied") {
  //     alert("You denied for the notification");
  //   }
  // }

  // useEffect(() => {
  //   // Memanggil fungsi permintaan izin ketika komponen App dipasang
  //   requestPermission();

  //   // Menambahkan event listener untuk menerima pesan push saat aplikasi berjalan
  //   const unsubscribe = onMessage(messaging, (payload) => {
     
  //     Toast(payload.notification);
  //   });

  //   // Membersihkan event listener saat komponen App dilepas
  //   return () => {
  //     unsubscribe();
  //   };
  // }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        <React.Suspense fallback={<LayoutSplashScreen />}>
          <BrowserRouter basename={basename}>
            <MaterialThemeProvider>
              <I18nProvider>
                <AuthInit>
                  <Routes />
                </AuthInit>
              </I18nProvider>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
